import OvenIcon from "../images/OvenIcon.mjs";

/**
 * App icon representing synthetic data (fake test data)
 * @see {GlyphIcon}
 * @see {OvenIcon}
 */
const AppSynthGenIcon = class extends OvenIcon {}

export default AppSynthGenIcon;